import Vue from "vue";
import "./styles/_base.scss";
import "../node_modules/modern-normalize/modern-normalize.css";
import "../node_modules/nprogress/nprogress.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import firebase from "firebase/app";
import "firebase/auth";
import { config } from "./firebaseConfig";

Vue.config.productionTip = false;

Vue.filter("dictionary", function (value) {
  if (!value) return "";
  value = value.toString();
  let regex = /(\b\w*)?\[(.*)\](\w*\b)?/gi;
  return value.replace(
    regex,
    '<span class="dict-link" data-word="$2">$1$2$3</span>'
  );
});

new Vue({
  router,
  store,
  created() {
    if (this.$store.state.analyticsOptOut === true) {
      this.$ga.disable();
    }
    firebase.initializeApp(config);
    firebase.auth().useDeviceLanguage();
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch("setUser", user);
      } else {
        this.$store.dispatch("logout");
      }
    });
  },
  render: (h) => h(App),
}).$mount("#app");
